import { parseDuration } from '../../common/time';
export const getDataStreamStore = (dataStreamId, resolution, store, aggregationType) => {
    var _a, _b, _c;
    const resolutionStreamStore = (_a = store === null || store === void 0 ? void 0 : store[dataStreamId]) === null || _a === void 0 ? void 0 : _a.resolutions;
    const rawDataStreamStore = (_b = store === null || store === void 0 ? void 0 : store[dataStreamId]) === null || _b === void 0 ? void 0 : _b.rawData;
    const parsedDuration = parseDuration(resolution);
    if (parsedDuration === 0 && rawDataStreamStore) {
        return rawDataStreamStore;
    }
    else if (resolutionStreamStore && aggregationType) {
        return (_c = resolutionStreamStore[parsedDuration]) === null || _c === void 0 ? void 0 : _c[aggregationType];
    }
    return undefined;
};
